import ImageInfo from '@/types/ImageInfo';

export default class Character {
    public characterId: string;
    public characterName: Map<string, string> = new Map<string, string>();
    public characterDescription: Map<string, string> = new Map<string, string>();
    public iconImage: ImageInfo;
    public images: ImageInfo[] = new Array<ImageInfo>();
}
